import type { SourceConversation } from 'lib-knowledge-remote-types/suggestions.types';
import { createContext, useContext } from 'react';

/**
 * Renders a set of conversations an article or draft was based on. The libs only
 * know each conversation's id (and, for a draft, its similarity); the host app
 * supplies this renderer because it alone can resolve richer display data.
 *
 * Injected via the `renderSourceConversations` prop on both
 * `AgentInterfaceSuggestions` and the knowledge management entry.
 */
export type SourceConversationsRenderer = (
  conversations: readonly SourceConversation[],
) => JSX.Element;

const SourceConversationsRendererContext = createContext<
  SourceConversationsRenderer | undefined
>(undefined);

export const SourceConversationsRendererProvider =
  SourceConversationsRendererContext.Provider;

export function useSourceConversationsRenderer():
  | SourceConversationsRenderer
  | undefined {
  return useContext(SourceConversationsRendererContext);
}
